<div class="document-gallery">
  @for (m of documents; track m.id) {
    <article class="document-gallery__item">
      <button
        type="button"
        class="document-gallery__preview"
        (click)="openPreview(m)"
        title="Visualizar documento"
      >
        @if (getFileType(m.fileName) === 'image') {
          <i class="bi bi-file-earmark-image" aria-hidden="true"></i>
        } @else {
          <span class="document-gallery__fallback" [ngClass]="'document-gallery__fallback--' + getFileType(m.fileName)">
            <i class="bi" [ngClass]="getFileIcon(m.fileName)"></i>
          </span>
        }
        <span class="document-gallery__type">{{ getFileTypeLabel(m.fileName) }}</span>
      </button>

      <div class="document-gallery__details">
        <div class="document-gallery__text">
          <span class="document-gallery__name" [title]="m.fileName">{{ m.fileName }}</span>
          <div class="document-gallery__meta">
            @if (m.documentTypeName) {
              <span class="document-gallery__document-type">{{ m.documentTypeName }}</span>
            }
            <span>{{ getFileSize(m.size) }}</span>
          </div>
        </div>

        <div class="document-gallery__actions">
          <button
            type="button"
            class="document-gallery__action document-gallery__action--view"
            (click)="openPreview(m)"
            title="Visualizar documento"
          >
            <i class="bi bi-eye"></i>
          </button>
          <a
            href="#" (click)="$event.preventDefault(); $event.stopPropagation(); download(m)"
            target="_blank"
            rel="noopener"
            download
            class="document-gallery__action document-gallery__action--download"
            title="Baixar documento"
          >
            <i class="bi bi-download"></i>
          </a>
          @if (showDelete) {
            <button
              type="button"
              class="document-gallery__action document-gallery__action--delete"
              (click)="delete.emit(m.id)"
              title="Excluir documento"
            >
              <i class="bi bi-trash"></i>
            </button>
          }
        </div>
      </div>
    </article>
  }
</div>

<app-modal
  [visible]="!!previewMedia()"
  [title]="previewMedia()?.fileName || ''"
  [subtitle]="getFileSize(previewMedia()?.size)"
  (close)="closePreview()"
  size="2xl"
>
  <div class="doc-preview-modal__body">
    @if (previewMedia()) {
      @if (getFileType(previewMedia()!.fileName) === 'image') {
        <div class="doc-preview-modal__image-wrapper">
          <img [src]="previewMedia()!.url" [alt]="previewMedia()!.fileName" class="doc-preview-modal__image" />
        </div>
      } @else if (getFileType(previewMedia()!.fileName) === 'pdf') {
        <iframe [src]="safePreviewUrl" class="doc-preview-modal__iframe" title="Visualização do PDF"></iframe>
      } @else {
        <div class="doc-preview-modal__unsupported">
          <div class="doc-preview-modal__unsupported-icon">
            <i class="bi bi-file-earmark-lock"></i>
          </div>
          <p class="doc-preview-modal__unsupported-text">Visualização direta indisponível</p>
          <p class="doc-preview-modal__unsupported-subtext">A visualização direta no navegador não é suportada para arquivos deste tipo (ex: Word, Excel).</p>
          <a [href]="previewMedia()!.url" target="_blank" rel="noopener" class="btn btn--primary flex items-center gap-2 mt-4">
            <i class="bi bi-box-arrow-up-right"></i> Baixar ou Abrir Documento
          </a>
        </div>
      }
    }
  </div>
</app-modal>
